module.exports = __webpack_public_path__ + "resources/img/solution_commerce_rescue2_m.1ad221be5e0dbfebfe8a8d80b9e8230b.png";